module.exports = __webpack_public_path__ + "img/banner-1.45b6da99.jpg";